import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseDateTime, stringifyDateTime } from '~/prix/types/dateTime'
import {
  parseBooleanValue,
  parseCsvCalendarDate,
  parseEnumEmptyString,
} from '~/prix/utils/bulk/csvValueParsers'

const prescribedDrugs: Dataset = {
  schema: 'public_health',
  table: 'prescribed_drugs',
  columnTransformMap: {
    original_id: original => original,
    data_source_id: original => original,
    attendance_original_id: original => original,
    catmat_code: original => original,
    dose_frequency_type: original => parseEnumEmptyString(original as string),
    dose_frequency: original => original,
    dose: original => original,
    dose_description: original => original,
    treatment_duration: original => original,
    administration_route: original => parseEnumEmptyString(original as string),
    is_single_dose: original => parseBooleanValue(original as string),
    is_continuous_dose: original => parseBooleanValue(original as string),
    prescribed_quantity: original => original,
    treatment_start_date: original => parseCsvCalendarDate(original as string),
    treatment_end_date: original => parseCsvCalendarDate(original as string),
    created_at: original => stringifyDateTime(parseDateTime(original as string)),
    updated_at: original => stringifyDateTime(parseDateTime(original as string)),
  },
}

export default prescribedDrugs
